<template>
	<div>
		<div class="page-title__actions-wrapper" v-if="isMyPost">
			<v-btn
				class="page-title__actions elevation-0"
				style="background-color: transparent !important; color: #0055A3 !important;padding-right: 0"
				@click="togglePostModal"
			>
				Edit
			</v-btn>
			<v-btn
				class="page-title__actions elevation-0"
				style="background-color: transparent !important; color: #F35858 !important; padding-right: 0"
				@click="toggleDeleteModal"
			>
				Delete
			</v-btn>
		</div>
		<v-card class='post-card elevation-0 d-flex flex-column pt-3 mb-15'>
			<div class='post-card__container'>
				<div class='post-card__outer'>
					<div class='d-flex post-card__list pl-0 pr-0 pt-6'>
						<ProfileBadge
							v-if="post.pin_to_top || post.sponsored_by"
							isPin
							:pin="pinnedType(post)"
						/>

						<div class='d-flex justify-space-between align-center px-4'>

							<router-link
								:to="{
								name: isCurrentUser(this.post.user.user_id) ? 'profile' : 'user-by-id',
								params: isCurrentUser(this.post.user.user_id) ? [] : {id: this.post.user.user_id}
							}"
								class="d-flex align-center text-decoration-none"
								:class="{ disabled: this.post.user.user_hidden }"
							>
								<Avatar
									class='mr-2 post-card__avatar'
									size='50'
									:avatar='this.post.user.user_logo'
								/>
								<div
									class='d-flex flex-column justify-center gap-4 post-card__meta'
								>
									{{ this.post.user.visible_username }}
									<span
										v-if="this.post.user.second_profile_row"
										class='post-card__meta-bottom'
									>
										{{ this.post.user.second_profile_row }}
									</span>

								</div>
							</router-link>

							<div class='post-card__meta-time'>
								{{ dateCreated }}
							</div>
						</div>

						<div
							class="pa-0 pt-5 post-preview-card__thumbnail-outer"
							v-if="this.post.thread_image"
						>
								<img
									v-if="isTextPost"
									class='post-card__thumbnail'
									:src='this.post.thread_image'
									alt='thread image'
									loading='lazy'
									@error="handleImageError"
								/>

							<div
								v-if="isPreviewVimeoModeActive"
								class='post-preview-card__thumbnail__vimeo'
							>
								<img
									class="post-preview-card__thumbnail"
									:src="this.post.thread_image"
									alt="thread image"
									loading="lazy"
									@error="handleImageError"
								/>
								<span
									@click='playVideo'
								></span>
							</div>
							<iframe
								v-if="!isPreviewVimeoModeActive && isVimeoVideo"
								:src="formateVimeoVideoLink"
								width="600"
								height="338"
								:ref="createUniqueIframeName(this.post)"
								allow="autoplay; encrypted-media"
								allowfullscreen
								@load='iframeLoaded'
							></iframe>

							<div
								v-if="isPreviewYoutubeModeActive"
								class='post-preview-card__thumbnail__youtube'
							>
								<img
									class="post-preview-card__thumbnail"
									:src="this.post.thread_image"
									alt="thread image"
									loading="lazy"
									@error="handleImageError"
								/>
								<span
									@click='playVideo'
								></span>
							</div>
							<iframe
								v-if="!isPreviewYoutubeModeActive && isYoutubeVideo"
								:src="formateYoutubeVideoLink"
								width="600"
								height="338"
								:ref="createUniqueIframeName(this.post)"
								allow="autoplay; encrypted-media"
								@load='iframeLoaded'
								allowfullscreen
							></iframe>
					</div>

					<a
						class="post-card__thread-action"
						v-if="threadActionVisible"
						:href="threadActionLink"
						target="_blank"
					>
						<span class="post-card__thread-action-title">
							{{ threadActionTitle }}
						</span>
						<v-icon class="post-card__thread-action-icon">
							mdi-chevron-right
						</v-icon>
					</a>

					<span class='px-4 pt-3 post-card__link'>
						<a :href='this.post.thread_link' target='_blank' @click="handlePostLinkClick">
							{{ this.removeQueryParams(this.post.thread_link) }}
						</a>
					</span>

						<v-card-text class='post-card__title pb-0 pt-5 px-4'>
							{{ this.post.thread_title }}
						</v-card-text>

						<v-card-text class='px-4 pb-3 post-card__content'>
							<div class='post-card__content-inner' v-html='postDescription' />
						</v-card-text>

						<Poll
							v-if="isPollPost"
							:poll="post.poll"
							:postId="post.thread_id"
							:post="post"
							@pollVoted="updatePost"
						/>

						<div v-if='post.uploads && post.uploads.length' class="post-attachments-container">
							<PostAttachments
								v-for='attachment in this.post.uploads'
								:key='attachment.upload_id'
								:attachment='attachment'
								class="post-attachment-item"
							/>
						</div>

						<v-card-subtitle
							class='post-card__meta-bottom d-flex align-center px-4 pa-0 mb-4'
						>
							<div v-show='this.post.tags.length !== 0'>
								<v-chip
									:color='tag.tag_bg_color'
									:text-color='tag.tag_txt_color'
									class='post-card__tag mr-2 mb-2 px-3 py-3'
									v-for='(tag, index) in this.post.tags'
									:key='index'
								>
									#{{ tag.tag }}
								</v-chip>
							</div>
						</v-card-subtitle>

						<v-divider />

						<div class='d-flex align-center justify-space-between mt-4 mb-4 px-4'>
							<div class='d-flex'>
								<v-btn
									v-if="enableLikesButton"
									class="post-preview-card__like-btn elevation-0 pa-0"
									@click="onLike"
								>
									<Icon
										type="like"
										:size="16"
										:color="isLiked ? '#a0a0a0' : 'var(--accent-color)'"
									/>
									<span
										class="ml-2"
										v-if="displayLikes"
										:class="
											isLiked
												? 'post-preview-card__like-counter-active'
												: 'post-preview-card__like-counter'
										"
									>
										{{ this.likes }}
									</span>
								</v-btn>
								<div
									v-if="enableAllComments && allowComments && displayCommentsCount"
									class="d-flex align-center justify-center"
									style="width: 64px"
								>
									<Icon
										type="comment"
										:size="16"
										color="var(--accent-color)"
										:pr="8"
									/>
									<span class="post-preview-card__like-counter">
										{{ this.commentsCount }}
									</span>
								</div>

								<div
									v-if="displayViews"
									class="d-flex align-center justify-center"
									style="width: 64px"
								>
									<Icon
										type="eye"
										:size="16"
										color="var(--accent-color)"
										:pr="8"
									/>
									<span class="post-preview-card__like-counter">
										{{ this.post.view_count }}
									</span>
								</div>
							</div>

							<div @click='onFollow' style='cursor: pointer'>
							<span class='post-preview-card__like-button d-flex align-center'>
								<Icon
									:type="this.isFollowed ? 'bookmark' : 'bookmark_empty'"
									:color="this.isFollowed ? '#a0a0a0' : 'var(--accent-color)'"
									:size="20"
									:pr="8"
								/>
								<span
									class='post-preview-card__book-button'
									:class="
										this.isFollowed
											? 'post-preview-card__book-button-active'
											: ''
									"
								>{{ isFollowed ? 'Bookmarked' : 'Bookmark' }}</span
								>
							</span>

							</div>

						</div>


						<v-divider />

						<div
							class='pa-5 post-card__comments-view'
							v-if='allowComments && enableAllComments'
						>
							<div
								v-if='this.comments.length === 0'
								class='d-flex pa-4 text-center'
							>
								<span style='width: 100%'>There are no comments on this moments.</span>
							</div>
							<Comment
								class='mb-5 mr-2'
								v-else
								v-for='item in normalizedComments'
								:key='item.id'
								:comment='item'
								:post='post'
							/>
						</div>

						<v-divider
							v-if='allowComments && enableAllComments'
						/>

						<div
							class='d-flex align-center px-4'
							v-if='allowComments && enableAllComments'
						>
							<div style='width: 100%' v-if='this.isAuthenticated'>
								<CommentForm
									class='mb-5 pl-0'
									:avatar='this.profile.user_logo'
									:parent='this.post'
								/>
							</div>
						</div>
					</div>
				</div>
				<CreatePostModal
					v-on:closeModal="togglePostModal"
					:show="isPostModalShow"
					:post="post"
					edit
				/>
				<ConfirmActionModal
					:show="isDeleteModalShow"
					@closeModal="toggleDeleteModal"
					@confirmAction="deletePost"
					title="Are you sure you want to delete this post? This action cannot be undone."
					actionName="Delete"
					:isLoading="isPostUpdating"
				/>
			</div>
		</v-card>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import { toggleDislike, toggleFollow, toggleLike, toggleUnFollow } from '@/api/post'
import { mapActions, mapGetters } from 'vuex'
import Avatar from '@/components/Avatar'
import pinnedIcon from '@/assets/images/icon-pinned.svg'
import likedIcon from '@/assets/images/postIcon/icon-liked.svg'
import likeIcon from '@/assets/images/postIcon/icon-like.svg'
import viewIcon from '@/assets/images/postIcon/icon-view.svg'
import commentIcon from '@/assets/images/postIcon/icon-comment.svg'
import commentedIcon from '@/assets/images/postIcon/icon-commented.svg'
import sponsoredStarIcon from '@/assets/images/icon-sponsored-star.svg'
import PostAttachments from '@/components/Post/PostAttachments'
import Comment from '@/components/Comment.vue'
import { normalizeComment } from '@/utils/helpers'
import Form from '@/mixins/Form'
import CommentForm from '@/components/Forms/CommentForm.vue'
import Poll from '@/components/Post/Poll.vue'
import CreatePostModal from '@/components/Modals/CreatePostModal'
import ConfirmActionModal from '../../components/Modals/ConfirmActionModal.vue'
import ProfileBadge from '@/components/ProfileBadge.vue'
import Dwh from '@/mixins/Dwh'

Vue.use(VueScrollTo)

const THREAD_VIDEO_TYPE = 3;
const VIDEO_TYPE_YOUTUBE = 1;
const VIDEO_TYPE_VIMEO = 2;
const THREAD_POLL_TYPE = 4;

export default {
	components: {
		CommentForm,
		Comment,
		Avatar,
		PostAttachments,
		Poll,
		CreatePostModal,
		ConfirmActionModal,
		ProfileBadge
	},
	mixins: [Form, Dwh],
	props: {
		post: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			offset: true,
			isLiked: false,
			isFollowed: false,
			likes: 0,
			commentsCount: 0,
			enableAllComments: false,
			notAvailableImage: require('@/assets/images/image_not_available.png'),
			pinnedIcon,
			likedIcon,
			commentIcon,
			commentedIcon,
			likeIcon,
			viewIcon,
			sponsoredStarIcon,
			previewMode: true,
			iframeElement: null,
			isPostModalShow: false,
			isDeleteModalShow: false
		}
	},
	computed: {
		...mapGetters('post', ['isCommentLoading', 'comments', 'isCommentUpdating', 'isPostUpdating']),
		...mapGetters('auth', ['profile', 'isAuthenticated']),
		...mapGetters('auth', ['isAuthenticated']),
		...mapGetters('settings', ['appCore']),

		whichView() {
			return this.view
		},
		isCurrentUserMentioned() {
			const currentUserId = this.profile.user_id;
			return this.contentFormateChangeMentions.some(item => {
				return item.link && item.link.params.id === currentUserId;
			});
		},
		dateCreated() {
			const date = new Date(this.post.publish_timestamp * 1000)
			const options = { year: 'numeric', month: 'long', day: 'numeric' }
			return date.toLocaleDateString('en-US', options)
		},
		allowComments() {
			return !!this.post.allow_comments
		},

		/**
		 * @returns Array
		 */
		normalizedComments: function() {
			return this.comments.map(item => normalizeComment(item))
		},
		isTextPost() {
			return this.post.thread_type !== THREAD_VIDEO_TYPE
		},
		isPollPost() {
			return this.post.thread_type === THREAD_POLL_TYPE
		},
		isPreviewVimeoModeActive() {
			if (this.isVimeoVideoWithPreviewImage) {
				if (this.previewMode) {
					return true;
				}
			}

			return false;
		},
		isVimeoVideoWithPreviewImage() {
			const {
				thread_type: type,
				thread_image: image,
				thread_video_type: videoType
			} = this.post || {}

			return type === THREAD_VIDEO_TYPE &&
				videoType === VIDEO_TYPE_VIMEO &&
				image
		},
		isVimeoVideo() {
			const {
				thread_type: type,
				thread_video_type: videoType
			} = this.post || {}

			return type === THREAD_VIDEO_TYPE &&
				videoType === VIDEO_TYPE_VIMEO
		},
		formateVimeoVideoLink() {
			const {
				thread_video_code: code
			} = this.post || {}

			const additionalParams = '?autoplay=1&mute=1'

			if (this.isVimeoVideoWithPreviewImage) {
				return `https://player.vimeo.com/video/${code}${additionalParams}`
			}

			return `https://player.vimeo.com/video/${code}`
		},
		isPreviewYoutubeModeActive() {
			if (this.isYoutubeVideoWithPreviewImage) {
				if (this.previewMode) {
					return true;
				}
			}

			return false;
		},
		isYoutubeVideo() {
			const {
				thread_type: type,
				thread_video_type: videoType
			} = this.post || {}

			return type === THREAD_VIDEO_TYPE &&
				videoType === VIDEO_TYPE_YOUTUBE

		},
		formateYoutubeVideoLink() {
			const { thread_video_code: code } = this.post || {}

			const additionalParams = '?autoplay=1&mute=1'

			if (this.isYoutubeVideoWithPreviewImage) {
				return `https://www.youtube.com/embed/${code}${additionalParams}`
			}

			return `https://www.youtube.com/embed/${code}`
		},
		postDescription() {
			const parser = new DOMParser()
			const doc = parser.parseFromString(this.post.thread_text, 'text/html')
			return doc.body.innerHTML
		},
		isMyPost() {
			return this.post.user.user_id === this.profile.user_id && !this.post.poll
		},
		threadActionVisible() {
			return this.post.threadActions.length && !!this.post.threadActions[0].action_link && !!this.post.threadActions[0].action_title
		},
		threadActionTitle() {
			return this.threadActionVisible ? this.post.threadActions[0].action_title : null
		},
		threadActionLink() {
			if (this.threadActionVisible) {
				const isCustomLink = this.post.threadActions[0].action_link.includes('http://') || this.post.threadActions[0].action_link.includes('https://')
				if (isCustomLink) {
					return this.post.threadActions[0].action_link
				} else {
					const match = this.post.threadActions[0].action_link.match(/:\/\/(.*)/)
					return match ? `${window.location.origin}/webapp/${match[1]}` : this.post.threadActions[0].action_link
				}
			}
			return null
		},
		currentMenuItem() {
			if (this.appCore) {
				const regex = /:\/\/(.+)/;
				const currentMenuItem = this.appCore.app_menu.find(item => {
					const match = item.url.match(regex)
					const result = match ? match[1] : null
					return result === 'threads' && item.params.thread_menu_id === +this.$route.query.thread_menu_id
				})
				return currentMenuItem
			}
			return null
		},
		displayViews() {
			if (this.currentMenuItem) {
				return !!this.currentMenuItem.params.display_views
			}
			return false
		},
		displayLikes() {
			if (this.currentMenuItem) {
				return !!this.currentMenuItem.params.display_likes
			}
			return false
		},
		enableLikesButton() {
			if (this.currentMenuItem) {
				return !!this.currentMenuItem.params.enable_likes_button
			}
			return false
		},
		displayCommentsCount() {
			if (this.currentMenuItem) {
				return !!this.currentMenuItem.params.display_comments_count
			}
			return false
		}
	},
	methods: {
		...mapActions('post', ['getPost', 'removePost']),

		navigateToComments() {
			if (!this.post.id) {
				return
			}

			this.$router.push({ name: 'SinglePost', params: { id: this.post.id } })
			setTimeout(() => {
				VueScrollTo.scrollTo('#comment-id', 1000)
			}, 500)
		},
		isCurrentUser(userId) {
			if (!this.profile) {
				return false
			}

			const {user_id: currentUserId} = this.profile
			return userId === currentUserId;
		},
		handleImageError() {
			this.post.thread_image = this.notAvailableImage
		},
		removeQueryParams(url) {
			if (!url) {
				return ''
			}

			let parsedUrl = new URL(url)
			parsedUrl.search = ''

			return parsedUrl.toString().slice(0, 65)
		},
		onLike() {
			if (this.isLiked) {
				if (this.likes === 0) {
					return
				}
				this.likes--
				toggleDislike(this.post.thread_id)
			} else if (!this.isLiked) {
				this.likes++
				toggleLike({ thread_id: this.post.thread_id })
				this.sendTrigger({
					category: 'Content',
					action: 'click_like_news_post',
					module: 'News Feed',
					data: this.post.thread_id,
					title: this.post.thread_title,
					content_chapter_id: this.post.chapter_id ? [this.post.chapter_id] : null
				})
			}

			this.isLiked = !this.isLiked
		},
		onFollow() {
			if (this.isFollowed) {
				toggleUnFollow(this.post.thread_id)
			} else if (!this.isFollowed) {
				toggleFollow({ thread_id: this.post.thread_id })
				this.sendTrigger({
					category: 'Content',
					action: 'click_bookmark_news_post',
					module: 'News Feed',
					data: this.post.thread_id,
					title: this.post.thread_title,
					content_chapter_id: this.post.chapter_id ? [this.post.chapter_id] : null
				})
			}

			this.isFollowed = !this.isFollowed
		},

		pinnedType(post) {
			let result = {}

			if (post.pin_to_top && post.sponsored_by) {
				return (result = { icon: sponsoredStarIcon, text: 'Sponsored by ' + post.sponsored_by })
			} else if (post.sponsored_by) {
				return (result = { icon: sponsoredStarIcon, text: 'Sponsored by ' + post.sponsored_by })
			} else if (post.pin_to_top) {
				result = { icon: pinnedIcon, text: 'Pinned' }
			} else {
				result = { icon: pinnedIcon, text: 'Pinned' }
			}

			return result
		},

		onPostEdit(post) {
			if (!post.id) {
				return
			}
			this.$router.push(`/post/${post.id}/edit`)
		},
		playVideo() {
			this.previewMode = false;
		},
		createUniqueIframeName(post) {
			const { thread_video_code: videoCode } = post || {}

			return `videoIframe_${videoCode}`
		},
		iframeLoaded() {
			const { thread_video_code: code } = this.post || {}

			this.iframeElement = this.$refs[`videoIframe_${code}`];
		},
		updatePost() {
			if (this.post.poll.display_poll) {
				this.getPost(this.$route.params.id)
			} else {
				this.$router.back()
			}
		},
		async deletePost() {
			const response = await this.removePost(this.post.thread_id)
			if (response) {
				this.toggleDeleteModal()
				this.$router.back()
			}
		},
		togglePostModal() {
			this.isPostModalShow = !this.isPostModalShow
		},
		toggleDeleteModal() {
			this.isDeleteModalShow = !this.isDeleteModalShow
		},
		handlePostLinkClick() {
			this.sendTrigger({
				category: 'Content',
				action: 'click_link_news_post',
				module: 'News Feed',
				data: this.post.thread_id,
				title: this.post.thread_title,
				content_chapter_id: this.post.chapter_id ? [this.post.chapter_id] : null
			})
		}
	},
	created() {
		if (this.post) {
			this.likes = this.post.upvote_count
			this.commentsCount = this.post.comments_count
			this.isLiked = this.post.upvote
			this.isFollowed = this.post.follow
		}

		if (+this.$route.query.enable_all_comments) {
			this.enableAllComments = true
		}
	},
}
</script>

<style lang='scss'>
.post-attachments-container {
	display: flex;
	flex-wrap: wrap;
	gap: 2px;
	padding: 10px 16px;
}

.post-attachment-item {
	flex: 0 0 auto;
}
.posts_buttons{
	margin-top: 6px;
	padding: 16px 0;
	display: flex;
	justify-content: flex-end;
	align-items: center;
}


.post-card {
	background: #f1f1f1 !important;

	&__container {
		width: 100%;
		height: 100%;
		border-radius: 10px !important;
		box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
		background: white !important;
	}

	&__content-inner {
		overflow-x: auto;
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		line-height: 18px;
		padding-top: 10px;

		img {
			width: 100%;
		}

		span {
			white-space: normal;
		}

		p {
			margin-bottom: 0;
		}

		h1 {
			font-size: 30px;
			padding-bottom: 8px;
			line-height: 30px;
		}
	}

	&__meta {
		font-family: Montserrat, sans-serif;
		fonst-style: normal;
		font-weight: bold;
		font-size: 18px;
		line-height: 20px;
		color: var(--username-category-title);
		letter-spacing: 0.36px;
		gap: 4px;

		&-bottom {
			color: var(--company-position-large);
			font-size: 16px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			line-height: 16px;
		}

		&-time {
			color: rgb(155, 155, 155);
			font-size: 12px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			text-align: right;
		}
	}

	&__avatar {
		img {
			object-fit: cover;
		}
	}

	&__outer {
	}

	&__list {
		position: relative;
		flex-direction: column;
	}

	&__link {
		color: var(--ceil-detail-text-color);
		font-size: 16px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		text-decoration: underline;
		cursor: pointer;

		a {
			color: var(--ceil-detail-text-color) !important;
		}
	}

	&__title {
		color: rgb(74, 74, 74);
		font-size: 18px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		letter-spacing: 0px;
		line-height: 22px;
		font-style: normal;
	}

	&__block-view {
		flex-direction: column;
		height: 73%;

		.post-preview-card__thumbnail-outer img {
			max-width: 100%;
		}
	}

	&__content {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 21px;
	}

	&__thumbnail {
		height: auto;
		width: 100%;
	}

	&__tag {
		padding: 6px;
		border-radius: 3px !important;
		color: rgb(74, 74, 74);
		font-size: 14px !important;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		height: 20px !important;
		cursor: pointer;

		span {
			min-width: 100% !important;
			width: 100%;
		}
	}

	&__like-button {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		line-height: 16px;
		color: #aaaaaa;

		&-active {
			color: #db7842 !important;
		}

		.theme--light.v-icon:focus::after {
			opacity: 0;
		}
	}

	&__share-button {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		line-height: 16px;
		color: #aaaaaa !important;
		cursor: pointer;

		.v-icon {
			transform: rotateY(180deg);
		}

		&:hover {
			span {
				color: #757575;
				text-decoration: underline;
			}
		}
	}

	&__book-button {
		color: var(--accent-color);
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		text-decoration: none;

		&-active {
			color: var(--accent-color) !important;
			text-decoration: underline;
		}

	}

	&__comments-view {
		background-color: #F3F3F6!important;
	}

	&__comment {
		color: rgb(74, 74, 74);
		background-color: rgb(246, 246, 246);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		letter-spacing: -0.43px;
		width: 100%;

		&::placeholder {
			color: rgb(160, 160, 160);
			font-size: 15px;
			font-weight: normal;
			letter-spacing: -0.43px;
		}

		&:focus {
			outline: none;
		}

		&-send {
			width: 38px;
			height: 22px;
			color: rgb(160, 160, 160);
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			text-decoration: underline;
			cursor: pointer;
		}
	}

	&__comments-button {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		line-height: 16px;
		display: flex;
		align-items: flex-end;
		color: #aaaaaa;
		cursor: pointer;

		&:hover {
			span {
				color: #757575;
				text-decoration: underline;
			}
		}
	}

	&__my-menu {
		margin-top: 20px;
		min-width: 175px !important;
		contain: initial !important;
		overflow: visible !important;

		&:before {
			content: '';
			position: absolute;
			left: 14px;
			top: 0;
			z-index: -1;
			border-radius: 3px;
			transform: translate(0, -50%) rotate(45deg);
			width: 20px;
			height: 20px;
			background: #fff;
			box-shadow: 0 0 11px rgb(0 0 0 / 14%);
		}
	}

	&__menu-dots {
		margin-left: 10px !important;
	}

	&__thread-action {
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		justify-content: space-between;
		text-decoration: none;
		padding: 0 16px 8px 16px;
		border-bottom: 1px solid #EAEAEA;

		&-title {
			color: var(--accent-color);
			font-family: Montserrat, sans-serif;
			font-size: 14px;
			font-weight: 700;
			line-height: 22px;
			text-decoration: underline;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
		}

		&-icon {
			color: #CECECE !important;
		}
	}

	@media screen and (max-width: 1904px) {
		&__block {
			flex: 0 0 100%;
		}
		&__list {
			flex: 0 0 75%;
		}
	}
	@media screen and (max-width: 1264px) {
		&__block {
			flex: 0 0 100%;
		}
		&__list {
			flex: 0 0 66%;
		}
	}

	@media screen and (min-width: 1264px) {
		&__container {
			max-width: 600px;
		}
	}
	@media screen and (max-width: 768px) {
		&__thumbnail {
			height: 100%;
			max-width: 100%;
		}
		&__default-thumbnail {
			max-height: 250px;
			height: 100%;
		}
		&__outer {
			flex-direction: column;
		}
	}
}

.dropdown-profile {
	padding: 15px;

	&__item {
		min-height: 30px !important;
		padding: 0;
	}

	&__title {
		color: #aaaaaa;
		font-size: 12px !important;
		line-height: 1.4 !important;
		font-family: 'Montserrat', sans-serif !important;
		font-weight: 600 !important;
	}

	&__title:hover {
		text-decoration: underline;
		color: black;
		transition: color 0.2s, background-color 0.2s, border-color 0.2s !important;
	}
}
.disabled {
	pointer-events: none;
}

.page-title {
	&__actions {
		font-size: 14px;
		font-weight: 700;
		text-transform: capitalize;
		text-decoration: underline;
		line-height: 17.07px;
		font-family: Montserrat, sans-serif;

		&-wrapper {
			background-color: transparent !important;
			display: flex;
			justify-content: flex-end;
		}
	}
}
.post-preview-card__book-button{
	text-decoration-line: underline;
}
</style>
